import request from "@/api/request";

export function baidu() {
    return request({
        url: 'https://60s.7se.cn/v2/baidu/hot',
        method: 'get'
    })
}

export function weibo() {
    return request({
        url: 'https://60s.7se.cn/v2/weibo',
        method: 'get'
    })
}

export function zhihu() {
    return request({
        url: 'https://60s.7se.cn/v2/zhihu',
        method: 'get'
    })
}
